<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>疫情管控</el-breadcrumb-item>
            <el-breadcrumb-item>核酸统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="content-main">
      <div class="search">
        <div class="search-left">
          <span style="width: 0.5vw;height: 4vh;background-color: #0490F9;margin-right: 1vw;"></span>
          <span v-if="search.flag == 1" style="color: #23d715;">核酸阴性统计</span>
          <span v-else-if="search.flag == 2" style="color: #E32932;">核酸阳性统计</span>
          <span v-else-if="search.flag == 3" style="color: #bebebe;">无核酸报告统计</span>
        </div>
        <div class="search-center">
          <div>
            <span style="width: 5vw;">姓名：</span><el-input v-model="search.name" @input="select" placeholder="请输入姓名" clearable></el-input>
          </div>
           <div>
            <span style="width: 6vw;">身份证：</span><el-input v-model="search.idCard" @input="select" placeholder="请输入身份证" clearable></el-input>
          </div>
           <div>
            <span style="width: 7vw;">核酸状态：</span><el-input v-model="search.days" oninput="value=value.replace(/[^\d\.]/g, '')" @input="select" placeholder="请输入核酸状态天数" clearable></el-input>
          </div>
        </div>
        <el-button type="primary" size="small" @click="exportExcel">导出表格</el-button>
      </div>
      <el-table :data="tableData" stripe style="width: 100%;margin-top: 2vh;" height="72vh" :header-cell-style="tableHeaderStyle">
        <el-table-column type="index" :index="indexMethod" label="序号" width="60"></el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.personName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号">
           <template slot-scope="scope">
             <span>{{ scope.row.idCard }}</span>
          </template>
        </el-table-column>
        <el-table-column label="健康码状态">
           <template slot-scope="scope">
             <img v-if="scope.row.healthLevel == 1" src="../../../assets/image/anKang-gress.png" style="height: 6vh;">
             <img v-else-if="scope.row.healthLevel == 2" src="../../../assets/image/anKang-yellow.png" style="height: 6vh;">
             <img v-else-if="scope.row.healthLevel == 3" src="../../../assets/image/anKang-red.png" style="height: 6vh;">
             <img v-else-if="scope.row.healthLevel == 4" src="../../../assets/image/anKang-no.png" style="height: 6vh;">
          </template>
        </el-table-column>
        <el-table-column label="采集时间">
          <template slot-scope="scope">
            <span>{{scope.row.collectDatetime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="检测时间">
          <template slot-scope="scope">
            <span>{{scope.row.testingDatetime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="核酸状态">
           <template slot-scope="scope">
             <div v-if="search.flag == 1">
               <img src="../../../assets/image/yinX.png">
               <p style="color: #23d715;">已过{{scope.row.days}}天</p>
             </div>
             <div v-else-if="search.flag == 2">
                <img src="../../../assets/image/yangX.png">
                <p style="color: #E32932;">已过{{scope.row.days}}天</p>
             </div>
             <div v-else-if="search.flag == 3">
                <p style="color: #bebebe;">暂无核酸</p>
             </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        search: {
          projectId: '',
          idCard: '',
          name: '',
          flag: '',
          days: ''
        },
        tableData: []
      }
    },
    mounted() {
      this.search.projectId = util.session.get('groupId')
      let flag = this.$route.query.flag
      this.search.flag = flag
      this.getData()
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum = val
        this.getData()
      },
      select(){
        this.pageNum = 1
        this.pageSize = 20
        this.getData()
      },
      getData(){
        this.search.pageSize = this.pageSize
        this.search.pageNum = this.pageNum
        myHttp.findProjectPersonNucleicAcidPage(this.search).then(resp => {
          if(resp.data.code == '200'){
            this.tableData = resp.data.data.projectPersonNucleicAcidPage.list || []
            this.total = resp.data.data.projectPersonNucleicAcidPage.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      //  导出
      exportExcel(){
        let token = util.session.get('token')
        window.open(
          base.url + '/personNucleicAcidTesting/exportProjectPersonNucleicAcidList?projectId=' + this.search.projectId + '&idCard=' + this.search.idCard
          + '&name=' + this.search.name + '&flag=' + this.search.flag + '&days=' + this.search.days + '&accessToken=' + token
        )
      },
      indexMethod(index){
        return (this.pageNum - 1) * this.pageSize + 1 + index
      },
      tableHeaderStyle({row, column, rowIndex, columnIndex}){
        if(rowIndex == 0){
          return 'background-color: #F5F7F9'
        }
      }
    },
  }
</script>

<style scoped>
.content-main{
  height: 85vh;
  background-color: #fff;
  border-radius: 6px;
  padding: 1vh 1vw;
}
.search{
  display: flex;
  justify-content: space-between;
}
.search-left{
  width: 12%;
  display: flex;
  align-items: center;
}
.search-center{
  width: 80%;
  display: flex;
}
.search-center > div {
  display: flex;
  align-items: center;
  margin-right: 1vw;
}
.table-header{
  background-color: #F5F7F9;
}
</style>